import ImageCardLink from './ImageCardLink';

export default ImageCardLink;
